import { render, staticRenderFns } from "./editreqlist.vue?vue&type=template&id=35fb937c&scoped=true"
import script from "./editreqlist.vue?vue&type=script&lang=js"
export * from "./editreqlist.vue?vue&type=script&lang=js"
import style0 from "./editreqlist.vue?vue&type=style&index=0&id=35fb937c&prod&lang=scss&scoped=true"
import style1 from "./editreqlist.vue?vue&type=style&index=1&id=35fb937c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb937c",
  null
  
)

export default component.exports